import { Image } from '@models/image';
import z from 'zod';

export type Area = z.infer<typeof Area>;

export interface AreaDraft extends Omit<Area, 'map'> {
  image?: File | Image | null;
}

export const Area = z.object({
  id: z.string(),
  name: z.string(),
  image: Image.or(z.instanceof(File)).nullish(),
});
